// extracted by mini-css-extract-plugin
module.exports = {"container":"OhSnap_container__3T-Tu","header":"OhSnap_header__73Ij0"};